"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        var dataCache;
        (function (dataCache) {
            let _cache = new Map();
            let _cleanupInterval;
            let _defaultTTL = 300000;
            function init(defaultTTL = 300000) {
                _defaultTTL = defaultTTL;
                clearInterval(_cleanupInterval);
                _cleanupInterval = window.setInterval(() => {
                    cleanup();
                }, 60000);
            }
            dataCache.init = init;
            function get(key) {
                const entry = _cache.get(key);
                if (!entry) {
                    return null;
                }
                if (Date.now() > entry.expiry) {
                    _cache.delete(key);
                    return null;
                }
                return entry.value;
            }
            dataCache.get = get;
            function set(key, value, ttl = _defaultTTL) {
                const entry = {
                    value,
                    expiry: Date.now() + ttl
                };
                _cache.set(key, entry);
            }
            dataCache.set = set;
            function del(key) {
                _cache.delete(key);
            }
            dataCache.del = del;
            function clear() {
                _cache.clear();
            }
            dataCache.clear = clear;
            function has(key) {
                const entry = _cache.get(key);
                if (!entry)
                    return false;
                return Date.now() <= entry.expiry;
            }
            dataCache.has = has;
            function cleanup() {
                const now = Date.now();
                const keysToDelete = [];
                for (const [key, entry] of _cache.entries()) {
                    if (now > entry.expiry) {
                        keysToDelete.push(key);
                    }
                }
                keysToDelete.forEach(key => _cache.delete(key));
            }
            function destroy() {
                clearInterval(_cleanupInterval);
                _cache.clear();
            }
            dataCache.destroy = destroy;
        })(dataCache = designerv2.dataCache || (designerv2.dataCache = {}));
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
